module.exports = __webpack_public_path__ + "img/img_1.0aed9dcc.png";